import { render } from "./SvgContainer.vue?vue&type=template&id=11f6e11c"
import script from "./SvgContainer.vue?vue&type=script&lang=js"
export * from "./SvgContainer.vue?vue&type=script&lang=js"

import "./SvgContainer.vue?vue&type=style&index=0&id=11f6e11c&lang=scss"

import exportComponent from "/home/runner/work/stpancras-backstage-app/stpancras-backstage-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__